// src/components/ErrorPage.jsx
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./ErrorPage.css"; // Optional: Add styles

const ErrorPage = ({ message = "Oups! Une erreur s'est produite.", statusCode = 404 }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  const handleHome = () => {
    navigate("/"); // Navigate to the home page
  };

  return (

	<div id="notfound">
		<div class="notfound">
			<div class="notfound-404">
				<h1>Oops!</h1>
				<h2>404 - The Page can't be found</h2>
			</div>
			<Link to={'/'}>Go TO Homepage</Link>
		</div>
	</div>

  );
};

export default ErrorPage;
